import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerSetting } from 'src/shared/models/module-manager/module-manager-setting.model';
import { DataSetUpdateMode, ReportingSetDefinition } from 'src/shared/models/pipeline-config/reporting-sets.models';
import { ReportingSetService } from '../../modules/reporting-set/reporting-set.service';

@Component({
    selector: 'cv-reporting-set-settings',
    templateUrl: './reporting-set-settings.component.html',
    styleUrls: ['./reporting-set-settings.component.scss']
})
export class ReportingSetSettingsComponent implements OnInit {

    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    definitions: ReportingSetDefinition[] = null;
    selectedReportingSet: ReportingSetDefinition;
    selectedDateField: string;
    dates: string[] = null;

    constructor(
        public service: ReportingSetService,
    ) {

    }

    async loadData() {
        const response = await this.service.loadReportingSetDefinitions();
        this.definitions = response.map(d => d.ReportingSetDefinition); // Extract just the Reporting Set Definition objects from the API response
        if (this.definitions?.[0]) {
            this.selectedReportingSet = this.definitions[0];
            this.onReportingSetSelected();
        }
    }

    async ngOnInit() {
        await this.loadData();

        this.moduleManager.registerEvents({
            onSettingsOpened: this.onSettingsOpened.bind(this),
        });

        this.moduleManager.addSetting({
            name: 'reportingSetName',
            getValue: () => this.selectedReportingSet.ReportingSetName,
            onSettingLoaded: (value) => {
                if (!value)
                    return;
                this.moduleManager.setModuleNameSuffix(value, true);
                if (this.definitions) {
                    this.selectedReportingSet = this.definitions.find(rs => rs.ReportingSetName === value);
                    this.onReportingSetSelected();
                }

            }
        } as ModuleManagerSetting<string>);

        this.moduleManager.addSetting({
            name: 'dateField',
            getValue: () => this.selectedDateField,
            onSettingLoaded: value => {
                if (value)
                    this.selectedDateField = value;
                else this.onReportingSetSelected(); // select first date using selected reportingSet
            }
        } as ModuleManagerSetting<string>);
        this.moduleManager.customSettingsAdded = true;
    }

    async onSettingsOpened(isFirstOpen: boolean) {
        if (!isFirstOpen && Date.now() > (this.service.lastDefinitionUpdate + 5000)) {
            await this.service.loadReportingSetDefinitions();
        }
    }

    onReportingSetSelected() {
        this.dates = this.selectedReportingSet ? Object.keys(this.selectedReportingSet.Dates) : [];

        if (this.selectedReportingSet.Mode === DataSetUpdateMode.DropAllOnImport)
            this.dates = ['[Current]', ...this.dates];

        if (this.dates.length > 0)
            this.selectedDateField = this.dates[0];
    }
}
